import { QueryFilter, QueryError, QueryOrderDirection } from "../../api/apiTypes";

export class Query<T> {
    Data: Array<T>;
    Distinct?: boolean;
    Filters?: Array<QueryFilter>;
    Members?: Array<string>;
    Order?: QueryOrder;
    Page?: QueryPage;
    Count?: number;
    Errors?: Array<QueryError>;

    constructor(collection: Array<T>, currentPage: number, pageSize: number, queryOrder?: QueryOrder, defaultSort?: { [key: string]: QueryOrderDirection }) {
        this.Data = collection.slice(pageSize * (currentPage - 1), (pageSize * (currentPage - 1)) + pageSize);
        this.Count = collection.length;

        const safeMembers = Array.isArray(collection) && collection.length > 0 && collection[0] != null
            ? Object.keys(collection[0])
            : [];

        if (defaultSort === null) {
            this.Order = null;
        }
        else if (defaultSort !== undefined) {
            const member = Object.keys(defaultSort);
            this.Members = safeMembers;
            this.Order = new QueryOrder(member[0], defaultSort[member[0]]);
        }
        else if (queryOrder === null) {
            this.Members = safeMembers;
            this.Order = new QueryOrder(this.Members[0], QueryOrderDirection.Ascending);
        } else {
            this.Order = queryOrder;
        }
        
        this.Page = new QueryPage(pageSize, currentPage, Math.ceil(collection.length / pageSize));
    }
}

export class QueryOrder {
    Member: string;
    Direction: QueryOrderDirection;

    constructor(member: string, direction: QueryOrderDirection) {
        this.Member = member;
        this.Direction = direction;
    }
}

export class QueryPage {
    Length: number;
    Current: number;
    Total?: number;

    constructor(length: number, current: number, total?: number) {
        this.Length = length;
        this.Current = current;
        this.Total = total;
    }
}
